import { render, staticRenderFns } from "./RaffleSerials.vue?vue&type=template&id=5e2447ae&scoped=true&"
import script from "./RaffleSerials.vue?vue&type=script&lang=js&"
export * from "./RaffleSerials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2447ae",
  null
  
)

export default component.exports